export default {
  catalogsEnabled: process.env.VUE_APP_CATALOGS_ENABLED !== 'false'
}
